import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Universal report display option. Display only — never changes journals, GL balances, profit or tax calculations.
export const useVatModeStore = create(
  persist(
    (set) => ({
      inclVat: false,
      setInclVat: (v) => set({ inclVat: !!v }),
    }),
    { name: 'report-vat-mode' },
  ),
);

export const vatModeLabel = (inclVat) => (inclVat ? 'Incl. VAT' : 'Excl. VAT');
